module.exports = __webpack_public_path__ + "img/inflammatory-response-image.ca49c1fd.png";